export default __webpack_public_path__ + "static/media/winter.386174f2.jpeg";